// Auto-generated: maps all REACT_APP_* env vars for local dev fallback
// CRA DefinePlugin replaces each process.env.REACT_APP_* with its literal value at build time
// In production (no .env), these resolve to undefined and the API config takes over
const envDefaults = {
  "REACT_APP_ABOUTUS_INTRO": process.env.REACT_APP_ABOUTUS_INTRO,
  "REACT_APP_ADDRESS_LOCALITY": process.env.REACT_APP_ADDRESS_LOCALITY,
  "REACT_APP_ADDRESS_MAP": process.env.REACT_APP_ADDRESS_MAP,
  "REACT_APP_ADDRESS_REGION": process.env.REACT_APP_ADDRESS_REGION,
  "REACT_APP_AIBI_URI": process.env.REACT_APP_AIBI_URI,
  "REACT_APP_API_BASE_URL": process.env.REACT_APP_NODEJS_API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  "REACT_APP_BACKGROUND_COLOR": process.env.REACT_APP_BACKGROUND_COLOR,
  "REACT_APP_BUSINESS_HIGHLIGHTS": process.env.REACT_APP_BUSINESS_HIGHLIGHTS,
  "REACT_APP_BUSINESSHOURS_LINE1": process.env.REACT_APP_BUSINESSHOURS_LINE1,
  "REACT_APP_BUSINESSHOURS_LINE2": process.env.REACT_APP_BUSINESSHOURS_LINE2,
  "REACT_APP_BUSINESSHOURS_LINE3": process.env.REACT_APP_BUSINESSHOURS_LINE3,
  "REACT_APP_BUSINESSHOURS_LINE4": process.env.REACT_APP_BUSINESSHOURS_LINE4,
  "REACT_APP_BUTTON_COLOR": process.env.REACT_APP_BUTTON_COLOR,
  "REACT_APP_BUTTON_TEXT": process.env.REACT_APP_BUTTON_TEXT,
  "REACT_APP_BYPASS_ITEM_ATTRIBUTE_MENU_NAME": process.env.REACT_APP_BYPASS_ITEM_ATTRIBUTE_MENU_NAME,
  "REACT_APP_CATEGORIES_FILTERED": process.env.REACT_APP_CATEGORIES_FILTERED,
  "REACT_APP_CATEGORYNAV_STICKYTOP": process.env.REACT_APP_CATEGORYNAV_STICKYTOP,
  "REACT_APP_CHECKOUT_MENU": process.env.REACT_APP_CHECKOUT_MENU,
  "REACT_APP_CLOSES_LINE1": process.env.REACT_APP_CLOSES_LINE1,
  "REACT_APP_CLOSES_LINE2": process.env.REACT_APP_CLOSES_LINE2,
  "REACT_APP_CONTACT_US_EMAIL": process.env.REACT_APP_CONTACT_US_EMAIL,
  "REACT_APP_CONTACT_US_EMAIL_1": process.env.REACT_APP_CONTACT_US_EMAIL_1,
  "REACT_APP_CONTACT_US_EMAIL_2": process.env.REACT_APP_CONTACT_US_EMAIL_2,
  "REACT_APP_CONTACT_US_PHONE": process.env.REACT_APP_CONTACT_US_PHONE,
  "REACT_APP_CONTENTFUL_ACCESS_TOKEN": process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
  "REACT_APP_CONTENTFUL_SPACE_ID": process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  "REACT_APP_DAYOFWEEK_LINE1": process.env.REACT_APP_DAYOFWEEK_LINE1,
  "REACT_APP_DAYOFWEEK_LINE2": process.env.REACT_APP_DAYOFWEEK_LINE2,
  "REACT_APP_DELIVERY": process.env.REACT_APP_DELIVERY,
  "REACT_APP_DELIVERY_CHARGE": process.env.REACT_APP_DELIVERY_CHARGE,
  "REACT_APP_DELIVERY_CHARGE_MESSAGE": process.env.REACT_APP_DELIVERY_CHARGE_MESSAGE,
  "REACT_APP_DELIVERY_DESC": process.env.REACT_APP_DELIVERY_DESC,
  "REACT_APP_DELIVERY_FREE_AMOUNT": process.env.REACT_APP_DELIVERY_FREE_AMOUNT,
  "REACT_APP_DELIVERY_INTERVAL": process.env.REACT_APP_DELIVERY_INTERVAL,
  "REACT_APP_DELIVERY_MINIMUM_AMOUNT": process.env.REACT_APP_DELIVERY_MINIMUM_AMOUNT,
  "REACT_APP_DINE_IN": process.env.REACT_APP_DINE_IN,
  "REACT_APP_DINE_IN_DESC": process.env.REACT_APP_DINE_IN_DESC,
  "REACT_APP_EKIOSK_VISITOR_ONLY": process.env.REACT_APP_EKIOSK_VISITOR_ONLY,
  "REACT_APP_ENABLE_BOLDPAYMENT": process.env.REACT_APP_ENABLE_BOLDPAYMENT,
  "REACT_APP_ENABLE_CHECKOUT_NAME": process.env.REACT_APP_ENABLE_CHECKOUT_NAME,
  "REACT_APP_ENABLE_COMMENT_PER_ITEM": process.env.REACT_APP_ENABLE_COMMENT_PER_ITEM,
  "REACT_APP_ENABLE_CREDIT_CARDS": process.env.REACT_APP_ENABLE_CREDIT_CARDS,
  "REACT_APP_ENABLE_EKIOSK": process.env.REACT_APP_ENABLE_EKIOSK,
  "REACT_APP_ENABLE_AI_ORDERING": process.env.REACT_APP_ENABLE_AI_ORDERING,
  "REACT_APP_ENABLE_ELOYALTY": process.env.REACT_APP_ENABLE_ELOYALTY,
  "REACT_APP_ENABLE_GIFT_CARDS": process.env.REACT_APP_ENABLE_GIFT_CARDS,
  "REACT_APP_ENABLE_MEAL_CREDIT": process.env.REACT_APP_ENABLE_MEAL_CREDIT,
  "REACT_APP_ENABLE_MENU": process.env.REACT_APP_ENABLE_MENU,
  "REACT_APP_ENABLE_MOCK_DATA": process.env.REACT_APP_ENABLE_MOCK_DATA,
  "REACT_APP_ORDERING_ONLY": process.env.REACT_APP_ORDERING_ONLY,
  "REACT_APP_ENABLE_QR_FOOTER": process.env.REACT_APP_ENABLE_QR_FOOTER,
  "REACT_APP_ENABLE_RESERVATION": process.env.REACT_APP_ENABLE_RESERVATION,
  "REACT_APP_ENABLE_REVENUE_CENTER": process.env.REACT_APP_ENABLE_REVENUE_CENTER,
  "REACT_APP_ENABLE_REWARDS": process.env.REACT_APP_ENABLE_REWARDS,
  "REACT_APP_ENABLE_RUBY": process.env.REACT_APP_ENABLE_RUBY,
  "REACT_APP_ELEVENLABS_AGENT_ID": process.env.REACT_APP_ELEVENLABS_AGENT_ID,
  "REACT_APP_ELEVENLABS_SIGNED_URL_ENDPOINT": process.env.REACT_APP_ELEVENLABS_SIGNED_URL_ENDPOINT,
  "REACT_APP_ENABLE_SAME_DAY_DELIVERY": process.env.REACT_APP_ENABLE_SAME_DAY_DELIVERY,
  "REACT_APP_ENABLE_SAME_DAY_PICKUP": process.env.REACT_APP_ENABLE_SAME_DAY_PICKUP,
  "REACT_APP_ENABLE_SAME_MENU_CART_ITEMS": process.env.REACT_APP_ENABLE_SAME_MENU_CART_ITEMS,
  "REACT_APP_ENABLE_SERVING_PERIOD": process.env.REACT_APP_ENABLE_SERVING_PERIOD,
  "REACT_APP_ENABLE_SI180": process.env.REACT_APP_ENABLE_SI180,
  "REACT_APP_SI180_PRIMCOLOR": process.env.REACT_APP_SI180_PRIMCOLOR,
  "REACT_APP_SI180_SECCOLOR": process.env.REACT_APP_SI180_SECCOLOR,
  "REACT_APP_SI180_BTNCOLOR": process.env.REACT_APP_SI180_BTNCOLOR,
  "REACT_APP_SI180_BGGREY": process.env.REACT_APP_SI180_BGGREY,
  "REACT_APP_ENABLE_SL": process.env.REACT_APP_ENABLE_SL,
  "REACT_APP_ENABLE_STAFF_ORDER": process.env.REACT_APP_ENABLE_STAFF_ORDER,
  "REACT_APP_ENABLE_SL_BYPASS_ONE_MENU": process.env.REACT_APP_ENABLE_SL_BYPASS_ONE_MENU,
  "REACT_APP_ENABLE_SL_BYPASS_ONE_REVENUE_CENTER": process.env.REACT_APP_ENABLE_SL_BYPASS_ONE_REVENUE_CENTER,
  "REACT_APP_ENABLE_TIP": process.env.REACT_APP_ENABLE_TIP,
  "REACT_APP_ENABLE_WORLDPAY": process.env.REACT_APP_ENABLE_WORLDPAY,
  "REACT_APP_ENABLE_ZEROTAX": process.env.REACT_APP_ENABLE_ZEROTAX,
  "REACT_APP_FOOTER_PROMOTEXT": process.env.REACT_APP_FOOTER_PROMOTEXT,
  "REACT_APP_FOREGROUND": process.env.REACT_APP_FOREGROUND,
  "REACT_APP_GEOCOORDINATES_LAT": process.env.REACT_APP_GEOCOORDINATES_LAT,
  "REACT_APP_GEOCOORDINATES_LONG": process.env.REACT_APP_GEOCOORDINATES_LONG,
  "REACT_APP_GOO_GL_MAPS": process.env.REACT_APP_GOO_GL_MAPS,
  "REACT_APP_GRECAPTCHA_SITEKEY": process.env.REACT_APP_GRECAPTCHA_SITEKEY,
  "REACT_APP_IMAGE_SRC": process.env.REACT_APP_IMAGE_SRC,
  "REACT_APP_ITEM_VIDEO": process.env.REACT_APP_ITEM_VIDEO,
  "REACT_APP_LINK_FACEBOOK": process.env.REACT_APP_LINK_FACEBOOK,
  "REACT_APP_LINK_INSTAGRAM": process.env.REACT_APP_LINK_INSTAGRAM,
  "REACT_APP_LINK_TIKTOK": process.env.REACT_APP_LINK_TIKTOK,
  "REACT_APP_LINK_TRIPADVISOR": process.env.REACT_APP_LINK_TRIPADVISOR,
  "REACT_APP_LINK_TWITTER": process.env.REACT_APP_LINK_TWITTER,
  "REACT_APP_LINK_YELP": process.env.REACT_APP_LINK_YELP,
  "REACT_APP_LINK_YOUTUBE": process.env.REACT_APP_LINK_YOUTUBE,
  "REACT_APP_LOGIN_CUSTOMER_NUMBER": process.env.REACT_APP_LOGIN_CUSTOMER_NUMBER,
  "REACT_APP_LOGIN_PAGE": process.env.REACT_APP_LOGIN_PAGE,
  "REACT_APP_LOGIN_ROOM_NUMBER": process.env.REACT_APP_LOGIN_ROOM_NUMBER,
  "REACT_APP_LOGO_HEIGHT": process.env.REACT_APP_LOGO_HEIGHT,
  "REACT_APP_LOGO_WIDTH": process.env.REACT_APP_LOGO_WIDTH,
  "REACT_APP_MEDIA_SRC": process.env.REACT_APP_MEDIA_SRC,
  "REACT_APP_NAVBAR_BGVARIANT": process.env.REACT_APP_NAVBAR_BGVARIANT,
  "REACT_APP_NEWUI_LW": process.env.REACT_APP_NEWUI_LW,
  "REACT_APP_OPENS_LINE1": process.env.REACT_APP_OPENS_LINE1,
  "REACT_APP_OPENS_LINE2": process.env.REACT_APP_OPENS_LINE2,
  "REACT_APP_PDFVIEWER_NOMENU": process.env.REACT_APP_PDFVIEWER_NOMENU,
  "REACT_APP_PICKUP": process.env.REACT_APP_PICKUP,
  "REACT_APP_PICKUP_DESC": process.env.REACT_APP_PICKUP_DESC,
  "REACT_APP_PICKUP_INTERVAL": process.env.REACT_APP_PICKUP_INTERVAL,
  "REACT_APP_PWA_ENABLE_VISITWEBSITE": process.env.REACT_APP_PWA_ENABLE_VISITWEBSITE,
  "REACT_APP_RESTAURANT_ADDRESS": process.env.REACT_APP_RESTAURANT_ADDRESS,
  "REACT_APP_RESTAURANT_NAME": process.env.REACT_APP_RESTAURANT_NAME,
  "REACT_APP_RESTAURANT_TAGLINE": process.env.REACT_APP_RESTAURANT_TAGLINE,
  "REACT_APP_RUBY_AI_URI": process.env.REACT_APP_RUBY_AI_URI,
  "REACT_APP_RUBY_CONVO_URI": process.env.REACT_APP_RUBY_CONVO_URI,
  "REACT_APP_SENIORLIVING_TAGLINE": process.env.REACT_APP_SENIORLIVING_TAGLINE,
  "REACT_APP_SERVER_ID": process.env.REACT_APP_SERVER_ID,
  "REACT_APP_SERVICE_CHARGE": process.env.REACT_APP_SERVICE_CHARGE,
  "REACT_APP_SERVICE_CHARGE_PERCENT": process.env.REACT_APP_SERVICE_CHARGE_PERCENT,
  "REACT_APP_SERVICE_FEE": process.env.REACT_APP_SERVICE_FEE,
  "REACT_APP_SERVICE_OPTIONS": process.env.REACT_APP_SERVICE_OPTIONS,
  "REACT_APP_SHOW_IMAGE_SRC": process.env.REACT_APP_SHOW_IMAGE_SRC,
  "REACT_APP_SITE": process.env.REACT_APP_SITE,
  "REACT_APP_SITE_ID": process.env.REACT_APP_SITE_ID,
  "REACT_APP_SITE_NAME": process.env.REACT_APP_SITE_NAME,
  "REACT_APP_STORE_ID": process.env.REACT_APP_STORE_ID,
  "REACT_APP_STREET_ADDRESS": process.env.REACT_APP_STREET_ADDRESS,
  "REACT_APP_SUBTITLE_SLIDER1": process.env.REACT_APP_SUBTITLE_SLIDER1,
  "REACT_APP_SUBTITLE_SLIDER2": process.env.REACT_APP_SUBTITLE_SLIDER2,
  "REACT_APP_SUBTITLE_SLIDER3": process.env.REACT_APP_SUBTITLE_SLIDER3,
  "REACT_APP_SUBTITLE_SLIDER4": process.env.REACT_APP_SUBTITLE_SLIDER4,
  "REACT_APP_SUBTITLE_SLIDER5": process.env.REACT_APP_SUBTITLE_SLIDER5,
  "REACT_APP_TEXT_COLOR": process.env.REACT_APP_TEXT_COLOR,
  "REACT_APP_TEXT_HIGHLIGHT": process.env.REACT_APP_TEXT_HIGHLIGHT,
  "REACT_APP_TITLE_SLIDER1": process.env.REACT_APP_TITLE_SLIDER1,
  "REACT_APP_TITLE_SLIDER2": process.env.REACT_APP_TITLE_SLIDER2,
  "REACT_APP_TITLE_SLIDER3": process.env.REACT_APP_TITLE_SLIDER3,
  "REACT_APP_TITLE_SLIDER4": process.env.REACT_APP_TITLE_SLIDER4,
  "REACT_APP_TITLE_SLIDER5": process.env.REACT_APP_TITLE_SLIDER5,
  "REACT_APP_USE_POINTS": process.env.REACT_APP_USE_POINTS,
  "REACT_APP_WELCOME_TITLE": process.env.REACT_APP_WELCOME_TITLE,
  "REACT_APP_ZIP_CODE": process.env.REACT_APP_ZIP_CODE,
};

export default envDefaults;
